import cn from "classnames";
import { useTranslation } from "react-i18next";

import { Dropdown, Typography, Button, Avatar } from "components";
import { useModalState } from "hooks";
import { ArrowDownAction } from "icons";
import { makeBEM } from "utils";

import "./index.scss";

export interface DropdownActionListProps {
  title: React.ReactNode;
  logo?: React.ReactNode;
  image?: string;
  arrowColor?: string;
  titleColor?: string;
}

const bem = makeBEM("dropdown-actions");

export const DropdownActionsList = ({
  title,
  logo,
  image,
  arrowColor = "#626262",
  titleColor,
  children,
}: React.PropsWithChildren<DropdownActionListProps>) => {
  const modal = useModalState();
  const avatar = image && <Avatar avatar={image} />;
  const { i18n } = useTranslation();

  return (
    <div className={bem()}>
      <Dropdown dropdownContent={children} open={modal.isOpen} onClose={modal.close}>
        <Button
          icon={logo ? logo : avatar}
          color="secondary"
          light
          auto
          onClick={modal.open}
          type="button"
          iconRight={i18n.dir() === "rtl"}
          style={{ backgroundColor: "transparent", ...(i18n.dir() === "ltr" && { paddingRight: 0 }) }}
        >
          <span className={bem("btn")}>
            <Typography as="span" fw={500} color={titleColor}>
              {title}
            </Typography>
            <ArrowDownAction
              className={bem("arrow", { open: modal.isOpen })}
              color={arrowColor}
              width="0.58rem"
              height="0.42rem"
            />
          </span>
        </Button>
      </Dropdown>
    </div>
  );
};

export interface DropdownActionItemProps extends React.HTMLAttributes<HTMLButtonElement> {
  selected?: boolean;
}

DropdownActionsList.Item = ({
  children,
  selected,
  className,
  ...props
}: React.PropsWithChildren<DropdownActionItemProps>) => {
  return (
    <button className={cn(bem("item", { selected }), className)} type="button" {...props}>
      {children}
    </button>
  );
};
